import React, { Component } from "react";

function FileList(props) {
 return (
 <div className="rrs-fine-box-10">
   
   <div className="rrs-fine-box-all">
     <a href={props.file_url.replace('http://','https://')} target="_blank"><sapn style={{color:"#0072bc"}}>{props.filename}</sapn></a>
  {props.viewMode === false && (
   <a href="#main" onClick={props.onClick}>  <i className="icon btn-delete-file" /></a>
   )}
   </div>
 </div>
 );
}

export default FileList;